import React from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LzCPage from '../Page';

interface LzPDashboardModule {
    path?: string;
    element?: React.ReactNode;
    icon?: React.ReactNode;
}

class LzYDashboard extends LzCPage {
    constructor(props: LzPDashboardModule) {
        super({
            variation: 'Page',
            ident: 'dashboard',
            rightsKey: '', // set empty so that it`s NOT taken from ident and does not hide the Dashboard link in nav
            icon: props?.icon || <DashboardIcon />,
            fullRoute: props?.path || '/',
            children: props?.element || <React.Fragment>TODO: Show default dashboard component...</React.Fragment>,
        });
    }
}

export default LzYDashboard;
